// extracted by mini-css-extract-plugin
module.exports = {"section":"contact-module--section--17veU","ctaText":"contact-module--ctaText--ZpSrO"};